<div *ngIf="isLoading && isOnline">
	<div class="container-card"
		#containerCardLoading
		[style.height.px]="containerCardLoading.clientWidth / ratio">
		<div class="container-fluid position-relative">
			<div class="loader center-block">
				<div class="spinner-border text-secondary progress-spinner"
					role="status"></div>
			</div>
		</div>
	</div>
</div>

<div *ngIf="!isLoading || !isOnline">
	<div class="container-card card-corner"
		*ngIf="type === 'corner'"
		#containerCardCorner
		[style.height.px]="containerCardCorner.clientWidth / ratio">
		<div class="container-fluid">
			<div class="row">
				<div class="col col-12 content">
					<a [class.default-cursor]="isOfflineArm"
						tabindex="0"
						[attr.href]="!item.ActionLink ? null : (item.ActionLink | sanitize : 'resourceUrl')"
						(click)="linkClicked(item.ActionType, item.ActionLink)"
						id="{{containerCardId+'_doc_link'}}"
						target="_blank"
						rel="noopener"
						class="card-image"
						[class.overlay-dark]="overlayThemeDefaultIsDark"
						[style.background-image]="'url(' + item.FeatureImage + ')'"
						[style.height.px]="containerCardCorner.clientWidth / ratio">
						<div class="inner-content"
							title=""
							*ngIf="!isOfflineArm">
							<div *ngIf="item.Title"
								class="title text-ellipsis"
								id="{{containerCardId+'-title'}}"
								role="text"
								[title]="item.Title | htmlText"
								[innerHTML]="item.Title"></div>
							<div *ngIf="item.Description"
								class="caption text-two-ellipsis"
								id="{{containerCardId+'-caption'}}"
								role="text"
								[title]="item.Description | htmlText"
								[innerHtml]="item.Description"></div>
							<div *ngIf="item.BrandImage || item.BrandName"
								class="logo">
								<span class="logo-img">
									<fa-icon [icon]="['fab', 'stumbleupon-circle']"
										role="img"
										aria-label="Logo"></fa-icon>
								</span>
								<span class="logo-text"
									id="{{containerCardId+'-logo-text'}}"
									role="textbox">{{item.BrandName}}</span>
							</div>
						</div>
					</a>

				</div>
			</div>
		</div>
	</div>

	<div class="container-card card-android"
		*ngIf="type === 'android'"
		#containerCardAndroid
		[style.height.px]="containerCardAndroid.clientWidth / ratio * 2">
		<div class="container-fluid">
			<div class="row">
				<div class="col col-12 content">
					<ng-container *ngIf="isOnline">
						<a [attr.href]="!item.ActionLink ? null : (item.ActionLink | sanitize : 'resourceUrl')"
							(click)="linkClicked(item.ActionType, item.ActionLink)"
							id="{{containerCardId+'_link'}}"
							target="_blank"
							rel="noopener"
							class="card-image"
							[style.background-image]="'url(' + item.FeatureImage + ')'"
							[style.height.px]="containerCardAndroid.clientWidth / ratio * 2">
						</a>
						<div class="inner-content">
							<div *ngIf="item.Title"
								class="title text-ellipsis"
								[innerHtml]="item.Title"
								id="{{containerCardId+'-title'}}"
								role="text"></div>
							<div *ngIf="item.Description"
								class="caption text-two-ellipsis"
								id="{{containerCardId+'-caption'}}"
								role="text"
								[innerHtml]="item.Description"></div>
							<div *ngIf="item.BrandImage || item.BrandName"
								class="logo">
								<span class="logo-img">
									<fa-icon [icon]="['fab', 'stumbleupon-circle']"
										role="img"
										aria-label="logo"></fa-icon>
								</span>
								<span class="logo-text"
									id="{{containerCardId+'-logo-text'}}"
									role="textbox">{{item.BrandName}}</span>
							</div>
						</div>
					</ng-container>
					<ng-container *ngIf="!isOnline">
						<div class="card-image default-cursor"
							[style.background-image]="'url(' + item.FeatureImage + ')'">
						</div>
						<div class="inner-content">
							<div *ngIf="item.Title"
								class="title text-ellipsis default-cursor"
								[innerHtml]="item.Title"
								id="{{containerCardId+'-title'}}"
								role="text"></div>
							<div *ngIf="item.Description text-two-ellipsis"
								class="caption text-two-ellipsis default-cursor"
								id="{{containerCardId+'-caption'}}"
								role="text"
								[innerHtml]="item.Description"></div>
							<div *ngIf="item.BrandImage || item.BrandName"
								class="logo default-cursor">
								<span class="logo-img default-cursor">
									<fa-icon [icon]="['fab', 'stumbleupon-circle']"
										role="img"
										aria-label="logo"></fa-icon>
								</span>
								<span class="logo-text"
									id="{{containerCardId+'-logo-text'}}"
									role="textbox">{{item.BrandName}}</span>
							</div>
						</div>
					</ng-container>
				</div>
			</div>
		</div>
	</div>

	<div class="container-card card-highlight"
		*ngIf="type === 'highlight'"
		#containerCardHighlight
		[style.height.px]="containerCardHighlight.clientWidth / ratio">
		<div class="container-fluid">
			<div class="row">
				<div class="col col-12 content">
					<a [attr.href]="!item.ActionLink ? null : (item.ActionLink | sanitize : 'resourceUrl')"
						(click)="linkClicked(item.ActionType, item.ActionLink)"
						id="{{containerCardId+'_article'}}"
						target="_blank"
						rel="noopener"
						class="card-image"
						[class.overlay-dark]="!overlayThemeDefaultIsLight"
						[class.default-cursor]="isOfflineArm"
						[style.background-image]="'url(' + item.FeatureImage + ')'"
						[style.height.px]="containerCardHighlight.clientWidth / ratio"
						style="background-color: #2f3447;">
						<div class="inner-content"
							title="">
							<div *ngIf="item.Title && !isOfflineArm"
								[title]="item.Title | htmlText"
								class="title text-ellipsis"
								id="{{containerCardId+'-title'}}"
								role="text"
								[innerHtml]="item.Title"></div>
						</div>
					</a>
				</div>
			</div>
		</div>
	</div>

	<div class="container-card card-article"
		*ngIf="type === 'article'"
		#containerCardArticle
		[style.height.px]="containerCardArticle.clientWidth / ratio">
		<div class="container-fluid">
			<a class="article-content"
				[class.default-cursor]="isOfflineArm"
				attr.aria-label="{{ item.Title | htmlText }}"
				[attr.href]="!item.ActionLink ? null : (item.ActionLink | sanitize : 'resourceUrl')"
				(click)="linkClicked(item.ActionType, item.ActionLink)"
				id="{{containerCardId+'_card_article'}}"
				target="_blank"
				rel="noopener">
				<div class="row"
					title="">
					<div class="card-image"
						[style.background-image]="'url(' + item.FeatureImage + ')'">
						<div *ngIf="item.BrandImage || item.BrandName"
							class="logo">
							<span class="logo-img">
								<fa-icon [icon]="['fab', 'stumbleupon-circle']"
									role="img"
									aria-label="logo"></fa-icon>
							</span>
							<span class="logo-text"
								id="{{containerCardId+'-logo-text'}}"
								role="textbox">{{item.BrandName}}</span>
						</div>
					</div>
					<div class="row w-100">
						<div class="col col-12 content">
							<div *ngIf="item.Title && !isOfflineArm"
								class="title text-ellipsis"
								[title]="item.Title | htmlText"
								[innerHtml]="item.Title"
								id="{{containerCardId+'-title'}}"
								[style.margin-top.px]="containerCardArticle.clientWidth * 0"
								[style.height.px]="containerCardArticle.clientWidth * 54 / 430"
								[style.line-height.px]="containerCardArticle.clientWidth * 27 / 430"
								role="text"></div>
							<div *ngIf="item.ActionLink && !isOfflineArm"
								[style.height.px]="containerCardArticle.clientWidth * 27 / 430"
								[style.line-height.px]="containerCardArticle.clientWidth * 27 / 430"
								class="read-more">
								<span class="link-label"
									role="text"
									id="{{containerCardId+'-caption'}}"
									[innerHTML]="item.Action"></span>
								<fa-icon [icon]="['fas', 'arrow-right']"
									role="img"
									aria-label="Arrow-Right"></fa-icon>
							</div>
						</div>
					</div>
				</div>
			</a>
		</div>
	</div>

	<div class="container-card card-article card-subpage-article"
		*ngIf="type === 'subpage-article'"
		#containerCardArticle
		[style.height.px]="containerCardArticle.clientWidth / ratio">
		<div class="container-fluid">
			<a class="article-content"
				[class.default-cursor]="isOfflineArm"
				[attr.href]="!item.ActionLink ? null : (item.ActionLink | sanitize : 'resourceUrl')"
				(click)="linkClicked(item.ActionType, item.ActionLink)"
				id="{{containerCardId+'_card_article'}}"
				target="_blank"
				rel="noopener">
				<div class="row"
					title="">
					<div class="card-image"
						[style.background-image]="'url(' + item.FeatureImage + ')'">
						<div *ngIf="item.BrandImage || item.BrandName"
							class="logo">
							<span class="logo-img">
								<fa-icon [icon]="['fab', 'stumbleupon-circle']"
									role="img"
									aria-label="logo"></fa-icon>
							</span>
							<span class="logo-text"
								id="{{containerCardId+'-logo-text'}}"
								role="textbox">{{item.BrandName}}</span>
						</div>
					</div>
					<div class="row w-100">
						<div class="col col-12 content">
							<div *ngIf="item.Title && !isOfflineArm"
								class="title text-ellipsis"
								[title]="item.Title | htmlText"
								[innerHtml]="item.Title"
								id="{{containerCardId+'-title'}}"
								[style.margin-top.px]="containerCardArticle.clientWidth * 13 / 436"
								[style.height.px]="containerCardArticle.clientWidth * 54 / 430"
								[style.line-height.px]="containerCardArticle.clientWidth * 27 / 430"
								role="text"></div>
							<div *ngIf="item.ActionLink && !isOfflineArm"
								[style.height.px]="containerCardArticle.clientWidth * 27 / 430"
								[style.line-height.px]="containerCardArticle.clientWidth * 27 / 430"
								class="read-more">
								<span class="link-label"
									role="text"
									id="{{containerCardId+'-caption'}}"
									[innerHTML]="item.Action"></span>
								<fa-icon [icon]="['fas', 'arrow-right']"
									role="img"
									aria-label="Arrow Right"></fa-icon>
							</div>
						</div>
					</div>
				</div>
			</a>
		</div>
	</div>

	<div class="container-card card-subpage-corner"
		*ngIf="type === 'subpage-corner'"
		#containerCardCornerArticle>
		<div class="container-fluid">
			<div class="row">
				<div class="col col-12 content">
					<a tabindex="0"
						attr.aria-label="{{ item.Title }} . {{ item.Description }}"
						[attr.href]="!item.ActionLink ? null : (item.ActionLink | sanitize : 'resourceUrl')"
						(click)="linkClicked(item.ActionType, item.ActionLink)"
						target="_blank"
						rel="noopener"
						class="card-image"
						[class.overlay-dark]="overlayThemeDefaultIsDark"
						[style.background-image]="'url(' + item.FeatureImage + ')'"
						id="{{containerCardId+'-article_link'}}">
						<div class="inner-content"
							title="">
							<div *ngIf="item.Title"
								class="title text-ellipsis"
								[title]="item.Title | htmlText"
								[innerHtml]="item.Title"
								id="{{containerCardId+'-title'}}"
								role="text"></div>
							<div *ngIf="item.Description"
								class="caption text-two-ellipsis">
								<div [title]="item.Description | htmlText"
									[innerHtml]="item.Description"
									id="{{containerCardId+'-caption'}}"
									role="text"></div>
							</div>
							<div *ngIf="item.BrandImage || item.BrandName"
								class="logo">
								<span class="logo-img">
									<fa-icon [icon]="['fab', 'stumbleupon-circle']"
										role="img"
										aria-label="logo"></fa-icon>
								</span>
								<span class="logo-text"
									id="{{containerCardId+'-logo-text'}}"
									role="textbox">{{item.BrandName}}</span>
							</div>
						</div>
					</a>
				</div>
			</div>
		</div>
	</div>

	<div class="container-card card-subpage-partner-corner"
		*ngIf="type === 'subpage-partner-corner'"
		#containerCardSidebarPartnerCorner>
		<div class="container-fluid">
			<div class="row">
				<a class="col col-12 image"
					[attr.href]="!item.ActionLink ? null : (item.ActionLink | sanitize : 'resourceUrl')"
					target="_blank"
					rel="noopener"
					id="{{containerCardId+'_side_article'}}"
					[style.background-image]="'url(' + item.FeatureImage + ')'">
					<div *ngIf="item.BrandImage || item.BrandName"
						class="logo">
						<span class="logo-img">
							<fa-icon [icon]="['fab', 'stumbleupon-circle']"
								role="img"
								aria-label="logo"></fa-icon>
						</span>
						<span class="logo-text"
							id="{{containerCardId+'-logo-text'}}"
							role="textbox">{{item.BrandName}}</span>
					</div>
					<div class="row">
						<div class="col col-12 content"
							title="">
							<div *ngIf="item.Title"
								class="title text-two-ellipsis"
								[title]="item.Title | htmlText"
								[innerHtml]="item.Title"
								id="{{containerCardId+'-title'}}"
								role="text"></div>
							<div *ngIf="item.ActionLink"
								class="read-more">
							</div>
						</div>
					</div>
				</a>
			</div>
		</div>
	</div>

</div>
